export default __webpack_public_path__ + "51e34eb5753bf700fcd75ddfb3c57921.png";